import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Fragment } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import Button from '../../../components/Button';
import CircledIcon from '../../../components/CircledIcon';
import PhoneFormModal from '../../../components/PhoneForm/PhoneFormModal';
import PhoneMessagingModal from '../../../components/PhoneForm/PhoneMessagingModal';
import PreferedCard from '../../../components/PreferedCard';
import useModal from '../../../hooks/useModal';
import DeleteModal from '../../widgets/deleteModal/DeleteModal';

const EnabledTextMessaging = () => {
  return (
    <div className={'fw-light text-fs-6 text-success'}>
      {'text enabled'}
      <FontAwesomeIcon icon={light('message-check')} className={'ms-3'} />
    </div>
  );
};

const PhoneTabContent = ({
  homePhone,
  setHomePhone,
  workPhone,
  setWorkPhone,
  mobilePhone,
  setMobilePhone,
  verified,
  setVerified,
  isHomePhoneChecked,
  setIsHomePhoneChecked,
  isWorkPhoneChecked,
  setIsWorkPhoneChecked,
  isMobilePhoneChecked,
  setIsMobilePhoneChecked,
}: any) => {
  const [
    showDeleteHomePhoneModal,
    handleDeleteHomePhoneShow,
    handleDeleteHomePhoneClose,
  ] = useModal();

  const [
    showDeleteWorkPhoneModal,
    handleDeleteWorkPhoneShow,
    handleDeleteWorkPhoneClose,
  ] = useModal();

  const [
    showDeleteMobilePhoneModal,
    handleDeleteMobilePhoneShow,
    handleDeleteMobilePhoneClose,
  ] = useModal();

  const [showAddNewPhoneModal, handleAddNewPhoneShow, handleAddNewPhoneClose] =
    useModal();

  const [
    showEditHomePhoneModal,
    handleEditHomePhoneShow,
    handleEditHomePhoneClose,
  ] = useModal();

  const [
    showEditWorkPhoneModal,
    handleEditWorkPhoneShow,
    handleEditWorkPhoneClose,
  ] = useModal();

  const [
    showEditMobilePhoneModal,
    handleEditMobilePhoneShow,
    handleEditMobilePhoneClose,
  ] = useModal();

  const [
    showMessagingModal,
    handleShowMessagingModal,
    handleCloseMessagingModal,
  ] = useModal();

  const handleSubmitPhone = (formData: any) => {
    if (formData.type === 'home') {
      setHomePhone(formData);
    }
    if (formData.type === 'work') {
      setWorkPhone(formData);
    }
    if (formData.type === 'mobile') {
      setMobilePhone(formData);
    }
    handleAddNewPhoneClose();
    handleEditHomePhoneClose();
    handleEditWorkPhoneClose();
    handleEditMobilePhoneClose();
    if (formData.messaging === 'enabled') handleShowMessagingModal();
  };

  const handleHomePhoneChecked = () => {
    setIsHomePhoneChecked(!isHomePhoneChecked);
    setIsWorkPhoneChecked(false);
    setIsMobilePhoneChecked(false);
  };

  const handleWorkPhoneChecked = () => {
    setIsWorkPhoneChecked(!isWorkPhoneChecked);
    setIsHomePhoneChecked(false);
    setIsMobilePhoneChecked(false);
  };

  const handleMobilePhoneChecked = () => {
    setIsMobilePhoneChecked(!isMobilePhoneChecked);
    setIsHomePhoneChecked(false);
    setIsWorkPhoneChecked(false);
  };

  return (
    <Fragment>
      <section className={'w-100 d-flex justify-content-between mt-7'}>
        <div className={'d-flex align-items-center'}>
          <CircledIcon variant={'icon-emphasized'} icon={light('phone')} />
          <h4 className={'ms-7 mb-0 text-sm-20-lg-32'}>My Phone Numbers</h4>
        </div>
        <div className={'d-none d-lg-block'}>
          <Button
            size={'sm'}
            rightIcon={light('circle-plus')}
            onMouseDown={handleAddNewPhoneShow}
          >
            Add new
          </Button>

          <PhoneFormModal
            showModal={showAddNewPhoneModal}
            handleClose={handleAddNewPhoneClose}
            handleSubmit={handleSubmitPhone}
          />
          <PhoneMessagingModal
            showModal={showMessagingModal}
            handleClose={handleCloseMessagingModal}
            phoneData={mobilePhone}
            isVerified={verified}
            setVerified={setVerified}
          />
        </div>
      </section>
      <Row className={'mt-5'}>
        <Col lg={4} className={'mt-7'}>
          <PreferedCard
            id="ph-1"
            title={homePhone.type}
            editButtonName={'Edit number'}
            onDelete={handleDeleteHomePhoneShow}
            onEdit={handleEditHomePhoneShow}
            onChange={handleHomePhoneChecked}
            checked={isHomePhoneChecked}
          >
            {
              <section className={'d-flex justify-content-between'}>
                <div className={'fw-light text-fs-6'}>{homePhone.phone}</div>
              </section>
            }
          </PreferedCard>
          <PhoneFormModal
            showModal={showEditHomePhoneModal}
            handleClose={handleEditHomePhoneClose}
            handleSubmit={handleSubmitPhone}
            existingPhone={homePhone}
          />
          <DeleteModal
            showModal={showDeleteHomePhoneModal}
            handleClose={handleDeleteHomePhoneClose}
            handleSubmit={handleDeleteHomePhoneClose}
            title="Delete Phone Number"
          >
            <Container>
              <Row className="text-fs-6">
                Are you sure you want to delete this phone number?
              </Row>
              <Row>
                <Col className="p-0 pt-4 col-12 col-lg-6">
                  <PreferedCard
                    className="border-light-gray"
                    id="pc-3"
                    title={homePhone.type}
                    isSwitch={false}
                    isDismissable={false}
                  >
                    {
                      <div className={'fw-light text-fs-6'}>
                        {homePhone.phone}
                      </div>
                    }
                  </PreferedCard>
                </Col>
              </Row>
            </Container>
          </DeleteModal>
        </Col>
        <Col lg={4} className={'mt-7'}>
          <PreferedCard
            id="ph-2"
            title={workPhone.type}
            editButtonName={'Edit number'}
            onDelete={handleDeleteWorkPhoneShow}
            onEdit={handleEditWorkPhoneShow}
            onChange={handleWorkPhoneChecked}
            checked={isWorkPhoneChecked}
          >
            {
              <section className={'d-flex justify-content-between'}>
                <div className={'fw-light text-fs-6'}>{workPhone.phone}</div>
              </section>
            }
          </PreferedCard>
          <PhoneFormModal
            showModal={showEditWorkPhoneModal}
            handleClose={handleEditWorkPhoneClose}
            handleSubmit={handleSubmitPhone}
            existingPhone={workPhone}
          />
          <DeleteModal
            showModal={showDeleteWorkPhoneModal}
            handleClose={handleDeleteWorkPhoneClose}
            handleSubmit={handleDeleteWorkPhoneClose}
            title="Delete Phone Number"
          >
            <Container>
              <Row className="text-fs-6">
                Are you sure you want to delete this phone number?
              </Row>
              <Row>
                <Col className="p-0 pt-4 col-12 col-lg-6">
                  <PreferedCard
                    className="border-light-gray"
                    id="pc-3"
                    title={workPhone.type}
                    isSwitch={false}
                    isDismissable={false}
                  >
                    {
                      <div className={'fw-light text-fs-6'}>
                        {workPhone.phone}
                      </div>
                    }
                  </PreferedCard>
                </Col>
              </Row>
            </Container>
          </DeleteModal>
        </Col>
        <Col lg={4} className={'mt-7'}>
          <PreferedCard
            id="ph-3"
            title={mobilePhone.type}
            editButtonName={'Edit number'}
            onDelete={handleDeleteMobilePhoneShow}
            onEdit={handleEditMobilePhoneShow}
            onChange={handleMobilePhoneChecked}
            checked={isMobilePhoneChecked}
          >
            {
              <section className={'d-flex justify-content-between'}>
                <div className={'fw-light text-fs-6'}>{mobilePhone.phone}</div>
                {verified && <EnabledTextMessaging />}
              </section>
            }
          </PreferedCard>
          <PhoneFormModal
            showModal={showEditMobilePhoneModal}
            handleClose={handleEditMobilePhoneClose}
            handleSubmit={handleSubmitPhone}
            existingPhone={mobilePhone}
          />
          <DeleteModal
            showModal={showDeleteMobilePhoneModal}
            handleClose={handleDeleteMobilePhoneClose}
            handleSubmit={handleDeleteMobilePhoneClose}
            title="Delete Phone Number"
          >
            <Container>
              <Row className="text-fs-6">
                Are you sure you want to delete this phone number?
              </Row>
              <Row>
                <Col className="p-0 pt-4 col-12 col-lg-6">
                  <PreferedCard
                    className="border-light-gray"
                    id="pc-3"
                    title={mobilePhone.type}
                    isSwitch={false}
                    isDismissable={false}
                  >
                    {
                      <div className={'fw-light text-fs-6'}>
                        {mobilePhone.phone}
                      </div>
                    }
                  </PreferedCard>
                </Col>
              </Row>
            </Container>
          </DeleteModal>
        </Col>
      </Row>
      <div className={'w-100 mt-7 d-flex flex-column d-lg-none'}>
        <Button
          variant={'primary-outline'}
          rightIcon={light('circle-plus')}
          onMouseDown={handleAddNewPhoneShow}
        >
          Add new
        </Button>
      </div>
    </Fragment>
  );
};

export default PhoneTabContent;
